import { render, staticRenderFns } from "./batchOptionSetting.vue?vue&type=template&id=4c8cf9d2&scoped=true&"
import script from "./batchOptionSetting.vue?vue&type=script&lang=js&"
export * from "./batchOptionSetting.vue?vue&type=script&lang=js&"
import style0 from "./batchOptionSetting.vue?vue&type=style&index=0&id=4c8cf9d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cf9d2",
  null
  
)

export default component.exports